'use strict';


var app             = require('mag-app'),

    md5             = require('./md5'),
    xorString       = require('./xor.string'),
    // sharedBackend   = require('./shared.backend').instance,

    parallel = require('cjs-async/parallel'),

    storageKey     = 'applications-storage',

    currentSessions = [],

    userFsStorage = core.storage,

    loader;


function loadTheme ( done ) {
    var globalOptions = core.config.options,
        xhr = new XMLHttpRequest();

    xhr.open('GET', globalOptions.stalkerHost + '/stalker_portal/server/api/launcher_profile.php?language=en&uid=' + app.stalker.session.userId);
    xhr.onload = function () {
        var config = null;

        try {
            config = JSON.parse(this.responseText);
        } catch ( error ) {
            console.log(error);
        }

        if ( config !== null ) {
            if ( config.options.themePath ) {
                config.theme = {
                    path: globalOptions.stalkerHost + '/stalker_portal/server/api/theme_css.php?uid=' +
                    app.stalker.session.userId + '&_=' + Date.now() + '&resolution=',
                    vars: null
                };

                xhr = new XMLHttpRequest();
                xhr.open('GET', config.theme.path + window.screen.height);

                xhr.onload = function () {
                    if ( this.status === 200 ) {
                        parent.extendCorePrototype('theme', config.theme);
                    }

                    done();
                };

                xhr.onerror = xhr.ontimeout = function () {
                    done();
                };

                xhr.send();
            }
        }
    };

    xhr.onerror = xhr.ontimeout = function () {
        done();
    };

    xhr.send();
}


function loadModules ( callback ) {
    app.stalker.request('modules', {
        onload: function ( error, response ) {
            var originPackages   = core.packages,
                resolvedPackages = [];

            // map = {
            //     'magcore-app-explorer': 'media_browser',
            //     'magcore-app-tv': 'tv',
            //     // apps: 'apps',
            //     // dvb: 'dvb',
            //     // tv_archive: 'tv_archive',
            //     // time_shift: 'time_shift',
            //     // time_shift_local: 'time_shift_local',
            //     // 'epg.reminder': 'epg.reminder',
            //     // 'epg.recorder': 'epg.recorder',
            //     // 'epg': 'epg',
            //     // 'epg.simple': 'epg.simple',
            //     'magcore-app-video-club': 'vclub',
            //     'magcore-app-audio-club': 'audioclub',
            //     'magcore-app-magic-cast': 'magiccast',
            //     // 'downloads_dialog': 'downloads_dialog',
            //     'magcore-app-downloads': 'downloads',
            //     'magcore-app-karaoke': 'karaoke',
            //     'magcore-app-radio': 'radio',
            //     'magcore-app-weather': 'weather.current',
            //     // 'widget.audio': 'widget.audio',
            //     // 'widget.radio': 'widget.radio',
            //     'magcore-app-records': 'records',
            //     // 'magcore-app-records': 'remotepvr',
            //     // 'magcore-app-records': 'pvr_local',
            //     'magcore-app-settings': 'settings',
            //     // 'course.nbu': 'course.nbu',
            //     // 'weather.day': 'weather.day',
            //     // 'cityinfo': 'cityinfo',
            //     // 'horoscope': 'horoscope',
            //     // 'anecdote': 'anecdote',
            //     // 'game.mastermind': 'game.mastermind',
            //     'magcore-app-personal-account': 'account'
            //     // 'demo': 'demo',
            //     // 'infoportal': 'infoportal',
            //     // 'internet': 'internet',
            //     // 'service_management': 'service_management',
            //     // 'logout': 'logout',
            //     // 'account_menu': 'account_menu'
            // }

            if ( !error && response ) {
                // resolve
                originPackages.forEach(function ( item ) {
                    var originName;

                    if ( item.type === 'app' ) {
                        originName = item.packageName;
                        if ( response.data.indexOf(originName) !== -1 ) {
                            // named as package
                            resolvedPackages.push(item);
                        }
                    } else {
                        resolvedPackages.push(item);
                    }
                });
                core.updatePackages(resolvedPackages);
            }
            callback();
        },
        ontimeout: callback,
        onerror: callback
    });
}

function loadStorage ( done ) {
    //window.top.sharedBackend = sharedBackend;
    app.stalker.request('storage/' + storageKey, {
        onload: function ( error, response ) {
            var Storage = require('./storage');

            console.log('APP STORAGE LAODED ' + JSON.stringify(response));

            if ( error ) {
                app.stalker.request('storage/', {
                    method: 'POST',
                    body: JSON.stringify({key: storageKey, value: '{}'})
                });
                Storage.init({});
            } else {
                Storage.init(JSON.parse(response.data.value));
            }

            parent.extendCorePrototype('Storage', Storage);

            done();
        },
        onerror: done,
        ontimeout: done
    });
}

function setHomeApp ( settings ) {
    var classicTvName = 'magcore-app-tv-classic',
        tvName = 'magcore-app-tv',
        classicTv = core.packageMap[classicTvName],
        tv = core.packageMap[tvName],
        homeApp;

    homeApp = userFsStorage.getItem('homeApp');
    console.log('homeApp ' + homeApp);
    console.log(JSON.stringify(['backend', core.backend]));

    if ( homeApp && core.packageMap[homeApp] ) {
        core.taskManager.setHomeApp(core.packageMap[homeApp]);
    } else {
        console.log(JSON.stringify(['show_after_loading', settings.show_after_loading]));
        if ( settings.show_after_loading === 'last_channel' ) {
            if ( homeApp ) {
                // settings exsits
                // if ( homeApp === 'last_channel' ) {
                //     // confirm(1);
                //     if ( classicTv ) {
                //         // confirm(2);
                //         userFsStorage.setItem('homeApp', classicTv.packageName);
                //         core.taskManager.setHomeApp(classicTv);
                //     } else if ( tv ) {
                //         // confirm(3);
                //         userFsStorage.setItem('homeApp', tv.packageName);
                //         core.taskManager.setHomeApp(tv);
                //     }
                // } else
                if ( homeApp === tvName && tv ) {
                    // confirm(4);
                    // settings saved to TV
                    userFsStorage.setItem('homeApp', tv.packageName);
                    homeApp = tv.packageName;
                    core.taskManager.setHomeApp(tv);
                } else if ( homeApp === classicTvName && classicTv ) {
                    // confirm(5);
                    // settings saved to classic TV
                    userFsStorage.setItem('homeApp', classicTv.packageName);
                    homeApp = classicTv.packageName;
                    core.taskManager.setHomeApp(classicTv);
                } else if ( homeApp === tvName && !tv && classicTv ) {
                    // confirm(4);
                    // classic TV exists, but settings saved to TV
                    userFsStorage.setItem('homeApp', classicTv.packageName);
                    homeApp = classicTv;
                    core.taskManager.setHomeApp(classicTv);
                } else if ( homeApp === classicTvName && !classicTv && tv ) {
                    // confirm(5);
                    // TV exists, settings saved to classic TV
                    userFsStorage.setItem('homeApp', tv.packageName);
                    homeApp = tv.packageName;
                    core.taskManager.setHomeApp(tv);
                } else if ( tv && classicTv ) {
                    // confirm(6);
                    homeApp = classicTv.packageName;
                    core.taskManager.setHomeApp(classicTv);
                } else if ( core.packageMap[homeApp] ) {
                    // confirm(7);
                    core.taskManager.setHomeApp(core.packageMap[homeApp]);
                }
            } else if ( classicTv ) {
                // new start
                // confirm(7);
                userFsStorage.setItem('homeApp', classicTvName);
                homeApp = classicTvName;
                core.taskManager.setHomeApp(classicTv);
            } else if ( tv ) {
                // new start without classic TV
                // confirm(8);
                userFsStorage.setItem('homeApp', tvName);
                homeApp = tvName;
                core.taskManager.setHomeApp(tv);
            }
        }
    }

    return homeApp;
}

function loadSettings ( done ) {
    function loadError () {
        var sharedBackend = require('./shared.backend');

        sharedBackend.instance.settings = {};
        done();
    }

    app.stalker.request('users/' + app.stalker.session.userId + '/settings', {
        onload: function ( error, data ) {
            var sharedBackend = require('./shared.backend');

            if ( !error && data ) {
                app.parentPassword = data.data.parent_password;

                core.environment.audioPrimaryLanguage = data.data.pri_audio_lang || data.data.languages[0];
                core.environment.audioSecondaryLanguage = data.data.sec_audio_lang || data.data.languages[1];
                core.environment.subtitlesPrimaryLanguage = data.data.pri_subtitle_lang || data.data.languages[0];
                core.environment.subtitlesSecondaryLanguage = data.data.sec_subtitle_lang || data.data.languages[1];

                sharedBackend.instance.settings = data.data;
                sharedBackend.instance.settings.homeApp = setHomeApp(data.data);
                sharedBackend.instance.settings.setHomeApp = function ( homeApp, callback ) {
                    var value;

                    if ( homeApp ) {
                        value = 'last_channel';
                    } else {
                        value = 'main_menu';
                    }

                    sharedBackend.instance.settings.homeApp = homeApp;
                    userFsStorage.setItem('homeApp', homeApp);

                    core.backend.request('users/' + core.backend.session.userId + '/settings', {
                        headers: {
                            'Content-Type': 'application/x-www-form-urlencoded'
                        },
                        method: 'PUT',
                        onload: function ( error, settingsPutResponse ) {
                            sharedBackend.instance.settings['show_after_loading'] = value;
                            // window.extendCorePrototype('backend', core.backend);
                            callback(error, settingsPutResponse);
                        },
                        onerror: function () {
                            callback(true);
                        },
                        body: 'show_after_loading=' + value
                    });
                };

                parent.extendCorePrototype('environment', core.environment);
            }

            console.log('onload ' + error);
            console.log(JSON.stringify(data));
            done();
            // core.events['show'] = null;
            // console.log('ready');
            // core.emit('ready', {stop: false});
        },
        onerror: loadError,
        ontimeout: loadError
    });
}

function loadUserData () {
    var tasks = [
        loadTheme,
        loadStorage
    ];


    if ( TARGET === 'android-stb' || TARGET === 'android-app' ) {
        tasks.push(loadModules);
    }

    parallel(tasks, function () {
        loadSettings(function () {
            core.events.show = null;
            core.emit('ready', {stop: false});
            setTimeout(function () {
                require('./shared.backend').instance.emit('ready');
            }, 0);
        });
    });
}


/* eslint max-lines-per-function: 0 */
function onStalkerCodeLoad ( config, instance ) {
    var sharedBackend = require('./shared.backend').instance,
        property;


    for ( property in instance ) {
        sharedBackend[property] = instance[property];
    }
    app.stalker = instance;

    if ( app.stalker.host === null && config.options.stalkerApiPath ) {
        if ( config.options.stalkerApiPath.indexOf('://') === -1 ) {
            // absolute path
            app.stalker.host = config.options.stalkerHost + config.options.stalkerApiPath;
        } else {
            app.stalker.host = config.options.stalkerApiPath;
        }
    }

    if ( app.stalker.authHost === null && config.options.stalkerApiPath ) {
        if ( config.options.stalkerApiPath.indexOf('://') === -1 ) {
            // absolute path
            app.stalker.authHost = config.options.stalkerHost + config.options.stalkerAuthPath;
        } else {
            app.stalker.authHost = config.options.stalkerAuthPath;
        }
    }
    app.stalker.lang = core.environment.language;
    app.stalker.saveCallback = function () {
        console.log('SAVE CALLBACK CALLED');
        if ( PLATFORM === 'MAG' ) {
            core.plugins.ufsJson.saveSync(app.stalker.session);
        } else {
            console.log(app.stalker.session);
            localStorage.setItem('ssession', JSON.stringify(app.stalker.session));
        }
    };
    app.stalker.reload = function () {
        core.reload(config.options.stalkerHost + config.options.stalkerLoaderPath);
    };
    app.stalker.onfail = function ( message ) {
        console.log('EXCEPTION IN REQUEST CALLBACK');
        console.log(JSON.stringify(message));
        if ( PLATFORM === 'SMARTTV' ) {
            window.top.alert(message);
        }
        //setTimeout(function () {
        //    core.notify({
        //        title: message, // текст нотификации
        //        icon: 'console.log',
        //        type: 'error',
        //        timeout: 5000
        //    });
        //}, 1000);
    };

    // load pages
    if ( config.options.stalkerHost ) {
        app.pages = {
            main: require('../pages/login'),
            accountDisabled: require('../pages/account.disabled')
        };
    } else {
        app.pages = {
            main: require('../pages/multi.login'),
            eula: require('../pages/eula')
        };
    }
    // show main page
    app.route(app.pages.main);

    // initiate global backend property with private data

    sharedBackend.host = config.options.stalkerHost + '/';
    sharedBackend.request = app.stalker.request;
    sharedBackend.session = config.session;
    //sharedBackend.withCredentials = false;

    if ( PLATFORM !== 'MAG' || TARGET === 'android-stb' || TARGET === 'android-app' ) {
        // smart tv's platforms and mag devices which running under android must have logout in personal account
        sharedBackend.logout = function () {
            sharedBackend.session = {};
            core.plugins.ufsJson.saveSync(sharedBackend.session);
            top.location.reload();
        };
    }

    parent.extendCorePrototype('backend', sharedBackend);
    parent.extendCorePrototype('stalker', sharedBackend);

    parent.addIntentHook('play', function ( intent, intentCreator ) {
        console.log('HOOKED');
        if ( intentCreator && intentCreator.config && intentCreator.config.resource && intent.data.mediaId ) {
            /* eslint camelcase: 0 */
            core.backend.request('media-info/', {
                method: 'POST',
                body: JSON.stringify({
                    type: intent.data.resource || intentCreator.config.resource,
                    media_id: intent.data.mediaId,
                    current_sessions: currentSessions
                }),
                onload: function ( error, data ) {
                    var sessionId, stopCallback;

                    if ( error ) {
                        console.log(error);
                        console.log(data);
                    } else {
                        console.log('statistic send ' + intent.data.uri);
                        sessionId = data.data.session_id;
                        currentSessions.push(sessionId);
                        console.log(JSON.stringify(data));
                        console.log('sessionId: ' + sessionId);
                        stopCallback = function () {
                            var index = currentSessions.indexOf(sessionId);

                            currentSessions.splice(index, 1);
                            //console.log('statistic deleted ' + intent.data.uri);
                            core.backend.request('media-info/' + sessionId, {
                                method: 'DELETE'
                            });
                        };

                        intent.once('close', function () {
                            if ( !(intent.data && intent.data.persistent) ) {
                                stopCallback();
                            }
                        });
                        intent.once('hide', stopCallback);
                        intent.once('exit', stopCallback);
                        intent.once('end', stopCallback);
                        intent.once('error', stopCallback);
                    }
                }
            });
        }
    });

    if ( PLATFORM === 'MAG' ) {
        if (
            (TARGET !== 'android-stb' || TARGET !== 'android-app')
            && core.config.options.userId === null
        ) {
            app.stalker.oncredenitalsrequired(function () {
                core.redirectTo(config.options.stalkerHost + config.options.stalkerLoaderPath);
            });
        } else if ( config.session && config.session.accessToken && config.session.userId ) {
            app.stalker.session = config.session;
            console.log('find session: ' + JSON.stringify(config.session));
            console.log('users/' + app.stalker.session.userId + '/ping');
            app.stalker.request('users/' + app.stalker.session.userId + '/ping', {
                onload: function ( error, data ) {
                    console.log('onload ' + error);
                    console.log(JSON.stringify(data));
                    loadUserData();
                },
                onerror: function ( exception ) {
                    console.log('onerror');
                    console.log(exception);
                    console.log(this.status);
                    console.log(this.readyState);
                    console.log(this.responseText);
                    loadUserData();
                },
                ontimeout: function ( request ) {
                    console.log('ontimeout');
                    console.log(request.status);
                    console.log(request.readyState);
                    console.log(request.responseText);
                    loadUserData();
                }
            });
            //console.log('app.stalker.request/');
        } else if ( config.session && config.session.refreshToken ) {
            app.stalker.auth.refreshToken(config.session.refreshToken, function ( error ) {
                console.log('refreshToken ERROR ' + error);
                if ( error ) {
                    app.stalker.auth.login({password: '', login: ''}, function ( error, result ) {
                        if ( error ) {
                            console.log(error);
                            console.log(result);
                            app.stalker.oncredenitalsrequired();
                        } else {
                            loadUserData();
                        }
                    });
                } else {
                    loadUserData();
                }
            });
        } else {
            app.stalker.auth.login({password: '', login: ''}, function ( error, result ) {
                console.log('empty login ERROR ' + JSON.stringify(error));
                if ( error ) {
                    if ( error.error_description === 'Account disabled' || error.error === 'firmware_outdated' ) {
                        app.stalker.oncredenitalsrequired(function () {
                            app.stalker.reload();
                        }, {
                            error: error
                        });

                        return;
                    }

                    app.stalker.oncredenitalsrequired(function () {
                        loadUserData();
                    });

                    console.log(error);
                    console.log(result);
                } else {
                    loadUserData();
                }
            });
        }
    } else {
        app.stalker.oncredenitalsrequired();
    }
}


loader = function ( config ) {
    var client;

    if ( TARGET === 'android-stb' || TARGET === 'android-app' ) {
        onStalkerCodeLoad(config, require('./api.provider'));

        return;
    }

    if ( PLATFORM !== 'MAG' ) {
        app.stalker = require('./stalker.api.unsecure');
        onStalkerCodeLoad(config, app.stalker);

        return;
    }

    if ( PLATFORM === 'MAG' ) {
        client = fetch();

        client.open('GET', config.options.sap + '?version=' + config.apiVersion);

        client.onload = function () {
            var instance = {},
                data, key, md5Key, rawData;


            data = this.responseText.split('.');
            key = atob(data.shift());
            md5Key = md5(key);
            rawData = atob(data[0]);

            key = core.tools.hash(key, md5Key);
            //console.log('key ' + key);
            //console.log('md5Key ' + md5Key);
            //console.log('data ' + rawData.length);

            data = xorString(rawData, key);

            data = data.replace(/gSTB/g, 'window.top.gSTB');
            if ( DEVELOP ) {
                data = data.replace('DEBUG=!1', 'DEBUG=!0');
            }
            console.log(data);

            try {
                /* eslint no-eval: 0 */
                instance = eval(data);
            } catch ( error ) {
                console.log(error);
            }

            onStalkerCodeLoad(config, instance);
        };

        client.onerror = function () {
            console.log('cant load api');
        };

        client.send();
    }
};


module.exports = loader;
